import { action, computed, makeObservable, observable } from 'mobx';

const OMNI_FILTER_MATCH_ALL_KEY = 'omniFilterMatchAll';

/**
 * Tiny app-wide preference for the omnifilter match mode, shared by every filter
 * surface (media + libraries, desktop + mobile). Persisted to localStorage so the
 * choice is remembered across reloads on this device. Default is match-any (false).
 *
 * A singleton (not a context store) so the MobX store computeds that do the actual
 * filtering (`LibraryFolder.files`, `LibraryManager.sortedAndFilteredLibraries`) can
 * read it reactively, alongside the React components.
 */
export class OmniFilterPreferencesStore {
  @observable
  _matchAll: boolean;

  constructor() {
    this._matchAll = localStorage.getItem(OMNI_FILTER_MATCH_ALL_KEY) === 'true';
    makeObservable(this);
  }

  /** true = every typed token must match (AND); false = any token may match (OR). */
  @computed
  get matchAll() {
    return this._matchAll;
  }

  @action
  setMatchAll(matchAll: boolean) {
    this._matchAll = matchAll;
    localStorage.setItem(OMNI_FILTER_MATCH_ALL_KEY, String(matchAll));
  }
}

export const omniFilterPreferences = new OmniFilterPreferencesStore();
